import React, { Component } from 'react';
import ReactApexChart from "react-apexcharts";

class DonutChart extends Component {

    constructor(props) {
        super(props);
        this.state = {
            options: {
                colors: ['#03dc6f', '#dc3d03'],
                stroke: {
                    width: 0,
                },
                labels: ["Thumbs up", "Thumbs down"],
                dataLabels: {
                    enabled: false
                },
                tooltip: {
                    enabled: false,
                },
                plotOptions: {
                    pie: {
                        size: 60,
                        expandOnClick: false,
                        donut: {
                            size: '75%',
                            labels: {
                                show: true,
                                name: {
                                    show: true,
                                    fontSize: '14px',
                                    fontFamily: 'fira sans, Arial, sans-serif',
                                    color: '#fff',
                                    offsetY: -12
                                },
                                value: {
                                    show: true,
                                    fontSize: '24px',
                                    fontFamily: 'fira mono, Arial, sans-serif',
                                    color: '#32B0EF',
                                    offsetY: -3,
                                    formatter: function (val) {
                                        return val
                                    }
                                },
                                total: {
                                    show: true,
                                    label: 'Total',
                                    color: '#fff',
                                    formatter: function (w) {
                                        return w.globals.seriesTotals.reduce((a, b) => {
                                            return a + b
                                        }, 0)
                                    }
                                }
                            }
                        }
                    }
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            show: false
                        }
                    }
                }],
                legend: {
                    position: 'bottom',
                    offsetY: -85,
                    height: 230,
                    fontSize: '14px',
                    fontFamily: 'fira sans, Arial sans-serif',
                    labels: {
                        useSeriesColors: true,
                    }
                }
            },
        }
    }

    render() {
        return (
            <div id="chart">  
                <ReactApexChart key={this.props.data} options={this.state.options} series={this.props.data} type="donut" width="500" height="250" />
            </div>
        );
    }
}

export default DonutChart;